'use strict'
module.exports = {
  NODE_ENV: '"production"',
  API_HOST: '"http://117.74.136.106:13310/"', // 生产
  // API_HOST:'"http://192.168.5.201:8081/"', // 测试
  // API_HOST:'"http://117.74.136.106:13312/"' // 测试
}



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = rBKV
// module chunks = 22